// Internal imports
import { Wrapper } from "./service-list-component.styles";
import { services } from "../../utils/data/data.utils";
import Service from "../service/service.component";

const ServicesList = () => {
  return (
    <Wrapper>
      {services?.map((service) => (
        <Service key={service.id} {...service} />
      ))}
    </Wrapper>
  );
};

export default ServicesList;
